interface RenderModeBadgeProps {
  mode: "channels" | "composite" | null | undefined;
  hasChannels?: boolean;
}

export function RenderModeBadge({ mode, hasChannels = false }: RenderModeBadgeProps) {
  if (!mode || !hasChannels) return null;

  if (mode === "channels") {
    return (
      <span
        className="rounded bg-violet-900/60 px-1.5 py-0.5 text-[10px] font-medium text-violet-300 ring-1 ring-violet-700/50"
        title="Renderizado com separação de canais (CMYK + especiais)"
      >
        Com Canais
      </span>
    );
  }
  return null;
}
